import React from 'react';
import clsx from 'clsx';

import TrailAnimation from '../animate/TrailAnimation';
import styles from './block-title.module.scss';

export const H3 = ({ first = false, children }) => (
  <TrailAnimation className={styles.title} component={<div />} delayBeforeStart={150}>
    <h3 className={clsx(styles.h3, first && styles.firstHeading)}>{children}</h3>
  </TrailAnimation>
);
